<p-chip
    class="custom-pill"
    [id]="id"
    [removeIcon]="'fa-solid fa-x fa-sm'"
    [removable]="false"
    (click)="clickPill.emit()">
    <span class="chip-name sort-chip">Sort By:&nbsp;</span>
    @for (item of data; track item; let i = $index) {
        <span class="chip-value">
            <span>
                {{ item.name | translate }}

                @if (item.numericalSort) {
                    @if (item.order === sortOrder.DESC) {
                        <i class="fa-solid fa-arrow-down-9-1"></i>
                    }
                    @if (item.order === sortOrder.ASC) {
                        <i class="fa-solid fa-arrow-down-1-9"></i>
                    }
                } @else {
                    @if (item.order === sortOrder.DESC) {
                        <i class="fa-solid fa-arrow-down-z-a"></i>
                    }
                    @if (item.order === sortOrder.ASC) {
                        <i class="fa-solid fa-arrow-down-a-z"></i>
                    }
                }

                @if (i !== data.length - 1) {
                    <span>, </span>
                }
            </span>
        </span>
    }
</p-chip>
